/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Insurance tariff.     * `Normal` **TODO** Welche Kfz Tarife haben wir?
 */
export const MotorVehicleTariff = {
  Normal: 'Normal',
} as const;
export type MotorVehicleTariff = (typeof MotorVehicleTariff)[keyof typeof MotorVehicleTariff];
